export type Member = {
  relationship: string;
  relationshipCode: string;
  firstName: string;
  middleName: string;
  lastName: string;
  birthDate: string;
  coveredIndividualId: string;
};

export type TobaccoInfo = {
  member: Member;
  isOverTobaccoAgeLimit: boolean;
  tobaccoIndicator: string;
  tobaccoUseEffectiveBeginDate: string;
  tobaccoUseEffectiveEndDate: string;
  tobaccoUseLastReportDate: string;
  tobaccoFreeStatus: string;
};

export type FamilyInfo = {
  clientNumber: string;
  clientId: string;
  groupNumber: string;
  groupId: string;
  internalGroupId: string;
  tobaccoList: Array<TobaccoInfo>;
};

export enum SHARED_LIBRARY_ASSET_KEYS {
  ATTENTION_ICON = 'ATTENTION_ICON',
  RIGHT_ARROW_ICON = 'RIGHT_ARROW_ICON',
  LEFT_ARROW_ICON = 'LEFT_ARROW_ICON',
  LEFT_ARROW_DISABLED_ICON = 'LEFT_ARROW_DISABLED_ICON',
  CROSS_ICON = 'CROSS_ICON',
  CALENDAR_ICON = 'CALENDAR_ICON',
  SUCCESS_ICON = 'SUCCESS_ICON',
  EXIT_WARNING = 'EXIT_WARNING',
}
